export enum ParticipantStatus {
  None = 0,
  Inactive = 1,
  InProgress = 2,
  Finished = 3,
  Abandoned = 4,
  Interview = 5,
  Accepted = 6,
}
